<template>
  <div>
    <v-row class="border-left--info border-left--5 mx-0">
      <v-col cols="12" class="pa-0" v-if="!hideDivider">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="auto" class="pr-0">
        <v-checkbox
          v-if="allowCompletion"
          hide-details
          class="py-0 my-0"
          color="info"
          v-model="completed"
          :disabled="disabled"
        ></v-checkbox>
        <v-chip color="info" v-else-if="actionItem" small class="mr-2">
          NEW
        </v-chip>
      </v-col>
      <v-col cols="auto" class="px-0">
        <due-date-chip
          v-if="actionItem"
          :dueDate="completed ? actionItem.completeDate : actionItem.dueDate"
          v-on:click="$emit('edit', actionItem)"
          :completed="completed"
        ></due-date-chip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" v-if="hideDivider && actionItem">
        <v-chip
          outlined
          label
          small
          color="info"
          class="light-background caption px-2"
          :to="
            `/meetings/${actionItem.checkInDefinitionId}/${actionItem.checkInId}`
          "
        >
          <v-icon size="15" class="mr-2">link</v-icon>
          {{ actionItem.checkInName }}
        </v-chip>
      </v-col>
      <v-col cols="auto" class="px-0">
        <user-avatar
          v-if="actionItem && actionItem.assignedTo"
          :size="20"
          :user="actionItem.assignedTo"
          cssClass="mr-n2 on-top"
          :toolTipText="`Assigned to ${actionItem.assignedTo.fullName}`"
        ></user-avatar>
      </v-col>
      <v-col cols="auto" class="pa-1 my-auto">
        <v-menu absolute>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              :disabled="completed || !actionItem || disabled"
            >
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="$emit('edit', actionItem)">
              <v-list-item-icon>
                <v-icon>edit</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>
            <v-list-item @click="addNote">
              <v-list-item-icon>
                <v-icon>chat</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Add Note</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="allowTalkingPoint && actionItem.relatedTalkingPointId"
              @click="$emit('talkingpoint')"
            >
              <v-list-item-icon>
                <v-icon>question_answer</v-icon>
              </v-list-item-icon>
              <v-list-item-title>View Talking Point</v-list-item-title>
            </v-list-item>
            <v-list-item @click="deleteActionItem()">
              <v-list-item-icon>
                <v-icon>delete</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col
        cols="12"
        v-if="actionItem"
        :class="
          'pt-0 secondarytext--text white-space-pre-line' +
            (completed ? ' text-decoration-line-through' : '') +
            (smallText ? ' font-weight-light subtitle-2' : '')
        "
      >
        {{ actionItem.text }}
      </v-col>
      <v-col
        cols="12"
        v-if="actionItem && actionItem.notes.length > 0"
        class="pt-0"
      >
        <v-btn
          small
          text
          color="lighttext"
          class="pa-0 mr-2"
          @click="show_notes = !show_notes"
        >
          {{ actionItem.notes.length }} Comments
          <v-icon small>
            {{ !show_notes ? "expand_more" : "expand_less" }}
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <template v-if="actionItem && show_notes">
      <template v-for="note in actionItem.notes">
        <note-line-item
          class="border-left--info border-left--5 mx-0"
          :key="note.id"
          :note="note"
          v-on:edit="editNote(note)"
          deleteAction="checkin/deleteActionItemNote"
          :disabled="completed"
        >
        </note-line-item>
      </template>
    </template>
    <edit-note-dialog
      ref="editNote"
      saveAction="checkin/saveActionItemNote"
      label="action item"
      v-on:save="$emit('redraw')"
    ></edit-note-dialog>
  </div>
</template>

<script>
import DueDateChip from "@/components/checkin/DueDateChip";
import { mapGetters } from "vuex";
import EditNoteDialog from "@/components/checkin/EditNoteDialog";
import NoteLineItem from "@/components/checkin/NoteLineItem";
export default {
  name: "ActionItemLineItem",
  components: {
    DueDateChip,
    EditNoteDialog,
    NoteLineItem
  },
  props: {
    actionItem: { type: Object },
    user: { type: Object },
    allowCompletion: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    completeAction: { type: String, default: "checkin/completeActionItem" },
    reopenAction: { type: String, default: "checkin/reopenActionItem" },
    hideDivider: { type: Boolean, default: false },
    smallText: { type: Boolean, default: false },
    allowTalkingPoint: { type: Boolean, default: false }
  },
  data: () => ({ show_notes: false }),
  watch: {
    show_notes(val, oldVal) {
      if (val != oldVal) {
        this.$emit("redraw");
      }
    }
  },
  computed: {
    completed: {
      get() {
        if (this.actionItem) {
          return this.actionItem.completeDate != null;
        }
        return false;
      },
      set(val) {
        if (!val) {
          this.reopen();
        } else {
          this.complete();
        }
      }
    },
    ...mapGetters({ profile: "profile/profile" })
  },
  methods: {
    complete() {
      this.$store
        .dispatch(this.completeAction, this.actionItem.id)
        .then(() => {
          this.$emit("save");
          this.$root.$snackbarSuccess("Action Item completed");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while completing an action item."
          );
        });
    },
    reopen() {
      this.$store
        .dispatch(this.reopenAction, this.actionItem.id)
        .then(() => {
          this.$emit("save");
          this.$root.$snackbarSuccess("Action Item reopened");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while reopening an action item."
          );
        });
    },
    async deleteActionItem() {
      if (
        await this.$root.$confirm(
          "Delete action item",
          "Are you sure you want to delete this action item?",
          { color: "red" }
        )
      ) {
        this.saving = true;
        this.$store
          .dispatch("checkin/deleteActionItem", this.actionItem.id)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Action Item deleted");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while deleting an action item."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    addNote() {
      this.$refs.editNote.showDialog({
        parentId: this.actionItem.id,
        text: "",
        userId: this.actionItem.userId
      });
    },
    editNote(note) {
      this.$refs.editNote.showDialog(note);
    }
  }
};
</script>

<style lang="scss" scoped>
.on-top {
  z-index: 100;
}
</style>
